import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';

import classNames from 'classnames/bind';
import { findLastIndex } from 'lodash';
import { scroller } from 'react-scroll';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
const PaginationButton = (props) => {
  const { item, currentCount, maxCount, listMaxPage, listMinPage } = props;
  const scrollToElement = (id, offset) => {
    scroller.scrollTo(id, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: offset,
    });
  };

  return (
    <div className={cx('pagination', maxCount <= 1 && 'pagination-hide')}>
      {currentCount !== 1 && (
        <img
          onClick={() => {
            let maxNum = listMaxPage - item <= item ? item : minNum + 4;
            let selectNumTemp = currentCount - 1;
            scrollToElement('root', 0);
            props.onChange(
              selectNumTemp * item,
              selectNumTemp < listMinPage ? listMinPage - item : listMinPage,
              selectNumTemp < listMinPage ? maxNum : listMaxPage,
            );
          }}
          src={require('../../../../assets/arrow_right_bold.png').default}
        />
      )}
      {(() => {
        let paginationList = [];
        for (let i = listMinPage; i <= listMaxPage; i++) {
          paginationList.push(
            <div
              key={i}
              onClick={() => {
                scrollToElement('root', 0);
                props.onChange(i * item, listMinPage, listMaxPage);
              }}
              className={cx(currentCount === i && 'page-select', 'subhead2')}
            >
              {i}
            </div>,
          );
        }
        return paginationList;
      })()}
      {currentCount < maxCount && (
        <img
          onClick={() => {
            let maxNum = listMaxPage + 5 > maxCount ? maxCount : listMaxPage + 5;
            let selectNumTemp = currentCount + 1;
            scrollToElement('root', 0);

            props.onChange(
              selectNumTemp * item,
              selectNumTemp > listMaxPage ? listMinPage + 5 : listMinPage,
              selectNumTemp > listMaxPage ? maxNum : listMaxPage,
            );
          }}
          src={require('../../../../assets/arrow_right_bold.png').default}
        />
      )}
    </div>
  );
};
export default observer(PaginationButton);
